function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();

  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
    this.dropDownHandle()
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };

  dropDownHandle(){
    document.querySelectorAll(".menu-drawer summary.menu-drawer__menu-item").forEach(heading =>{
      heading.addEventListener("click", ()=>{
        const content = heading?.nextElementSibling
        if(!content) return
        heading.classList.toggle("open")
        //content.style.height === '' ? content.style.height = content.scrollHeight + "px" : content.style.height = ''
        if (content.style.height) {
          content.style.height = content.scrollHeight + "px"
          setTimeout(()=>{
            content.style.height = '';
          }, 0);

        } else {
          content.style.height = content.scrollHeight + 'px';
          setTimeout(()=>{
            content.style.height = "auto"
          }, 300);
        }
      })
    })
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.jsonProduct = JSON.parse(document.querySelector("#product-variant-json")?.innerHTML) || [];
    this.addEventListener('change', this.onVariantChange);
    this.updateNameOption();
    this.updatePriceVariant();
  }

  onVariantChange() {
    this.updatePriceVariant();
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    this.updateNameOption();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }
  updateNameOption() {
    const variantInputs = this.querySelectorAll("input");
    variantInputs.forEach( input => {
      if (input.checked) {
        const variantName = input.closest('fieldset').querySelector(".form__label--name");
        variantName.innerHTML = input.value;
      }
    })
  }

  updatePriceVariant() {
    const variantInputs = this.querySelectorAll("input:not([data-package])").length !== 0 
      ? this.querySelectorAll("input:not([data-package])") 
      : this.querySelectorAll("input[data-package]") ;
    const variantInputsPackage = this.querySelectorAll("input[data-package]");
    const packageComparePrice = this.querySelectorAll(".form-package__compare-price");
    const packagePrice = this.querySelectorAll(".form-package__price");

    if (!variantInputsPackage.length && !packagePrice.length) return;

    packagePrice.forEach(priceTag => priceTag.classList.add("form-package__price--hide"));
    packageComparePrice.forEach(priceTag => priceTag.classList.add("form-package__compare-price--hide"));

    variantInputs.forEach((variantInput) => {
      if (variantInput.checked) {
        const { value, dataset: { position } } = variantInput;
        const filterJsonProduct = [...this.jsonProduct].filter( (product,_index, array) => {
          const isRegularInput = this.querySelectorAll("input:not([data-package])").length !== 0;
          const condition =  isRegularInput ? product[position] === value : array;
          return condition
        })
       
        variantInputsPackage.forEach((variantPackage, index) => {
          const { value, dataset: { position } } = variantPackage;
          const currentVariant = filterJsonProduct.find((product) => product[position] == value);
          if (currentVariant.compare_at_price != null) {
            this.changePriceHtml(currentVariant.compare_at_price, packageComparePrice[index], "form-package__compare-price--hide");
          }
          this.changePriceHtml(currentVariant.price, packagePrice[index], "form-package__price--hide");
        });
        return;
      }
    });
  }

  changePriceHtml(newDigit, element, className) {
    if (!element && !newDigit) return;
    let regex = /\d+(\.\d+)?/g;
    element.innerHTML = element.innerHTML.replace(regex, (newDigit / 100).toFixed(2));
    element.classList.remove(className);
  }
  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource?.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
        return {
          html, 
          variant: this.currentVariant.id,
          sectionId
        }
      }).then( ({html,variant,sectionId}) => {
        
        const cartItemDestination = document.getElementById(`Cart-items-${this.dataset.section}`);
        const cartItemCourse = html.getElementById(`Cart-items-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);

        const currentPricesDestination = document.querySelectorAll(".product .current-price");
        const currentPricesSourse = html.querySelectorAll(".current-price");

        if (cartItemCourse && cartItemDestination ) {
          cartItemDestination.replaceWith(cartItemCourse);
        }

        if (currentPricesSourse.length != 0) {
          currentPricesSourse.forEach( (price,index) => price.replaceWith(currentPricesSourse[index]) )
        }

        const productButtonsWrapperDestination = document.getElementById('product-buttons');
        const productButtonsWrapperCourse = html.getElementById('product-buttons');

        if (productButtonsWrapperDestination && productButtonsWrapperCourse ) {
          productButtonsWrapperDestination.replaceWith(productButtonsWrapperCourse);
        }
        if(window.innerWidth < 751) {
          document.dispatchEvent(new CustomEvent('button:render', {
            bubbles: true, 
            detail: {
              "url": this.dataset.url,
              "variant": variant,
              "sectionId": sectionId
            }
          }));
        }

      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      const markup = fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });

        markup.then(() => {
          document.dispatchEvent(new CustomEvent('init:related-slider', { bubbles: true }));
        }).catch( (error) => {
          console.log(error);
        })

    };


    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);


class CardActions extends HTMLElement {
  constructor() {
      super();
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.actionButtons = this.querySelectorAll("[data-action-button]")
      this.quantity = this.querySelector("[data-quantity]")
      this.actionButtons.forEach(button => {
          button.addEventListener("click", () => this.addToCart.call(this, button))
      })

      this.minusButton = this.actionButtons[0];
      this.plusButton = this.actionButtons[1];
  }
  updateForm(button, quantity) {
      this.quantity.value = quantity
      this.setAttribute("data-product-quantity", quantity)
      if (button.dataset.actionButton == "increase") {
          if (this.minusButton.hasAttribute("disabled"))
              this.minusButton.removeAttribute("disabled")
      } else {
          if (this.plusButton.hasAttribute("disabled"))
              this.plusButton.removeAttribute("disabled")
      }
      if (+this.quantity.value >= +this.quantity.max || +this.quantity.value <= 0)
          button.setAttribute("disabled", true)
      if (+this.quantity.value > 0) {
          this.setAttribute("data-closed", false)
      }
      else {
          this.setAttribute("data-closed", true)
      }
  }
  handleDataConfig(button) {
      let typeRequest = "add"
      let quantity = 1
      if (button.dataset.actionButton != "increase") {
          typeRequest = "change"
          quantity = +this.quantity.value - 1
      }
      return { quantity, typeRequest }
  }

  addToCart(button) {
      if (this.dataset.productId == "") {
          return
      }

      if (!localStorage.getItem('postal_code') || !localStorage.getItem('delivery_city')) {
        const deliveryPopup = document.querySelector('delivery-popup') || null;
        /* REDESIGN 2026-08-14 — REMEMBER THE ADD AND RETRY IT.
           This used to open the popup and return, so after entering a postal
           code nothing was added: the tap that triggered the gate was thrown
           away and you had to press + again, with no indication why. */
        window.__ubPendingAdd = () => this.addToCart(button);
        deliveryPopup?.showPopup(deliveryPopup);
        return;
      }

      let { quantity, typeRequest } = this.handleDataConfig(button)
      let formData = {
          'id': this.dataset.productId,
          'quantity': quantity,
          'sections': this.cart?.getSectionsToRender().map((section) => section.id)
      };
      const config = fetchConfig('json');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.body = JSON.stringify(formData);

      fetch(`/cart/${typeRequest}.js`, config)
          .then((response) => response.json())
          .then(response => {
              if (response.status) {
                  return
              } if (this.cart) {
                  if (!(this.cart.notification && typeRequest == 'change')) {
                      if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
                      this.cart?.renderContents(response);
                      if (this.cart.querySelector("cart-drawer-items")?.classList.contains('is-empty')) this.cart.classList.add('is-empty')
                  }
                  const newQuantity = response.quantity
                      ?
                      response.quantity
                      :
                      response.items.filter(item => item.id == this.dataset.productId)?.length > 0
                          ? response.items.filter(item => item.id == this.dataset.productId)[0].quantity
                          : 0

                  this.updateForm(button, newQuantity)
              }
              else {
                  window.location.href = "/cart"
              }
          })
          .catch((error) => {
              console.error('Error:', error);
          });
  }
}
customElements.define("card-actions",CardActions)

class ProductAddCart extends HTMLElement {
  constructor() {
      super();
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.actionButtons = this.querySelectorAll("[data-action-button]")
      this.quantity = this.querySelector("[data-quantity]")
      this.actionButtons.forEach(button => {
          button.addEventListener("click", () => this.addToCart.call(this, button))
      }) 
      
      this.minusButton = this.actionButtons[0];
      this.plusButton = this.actionButtons[1];

      this.variantSelect = new VariantSelects || null
      this.jsonProduct = JSON.parse(document.querySelector("#product-variant-json")?.innerHTML);
  }
  renderProductAddCart() {
      const isClassProductAddCart = this instanceof ProductAddCart
      const self = isClassProductAddCart ?  document.querySelector("product-add-cart") : this;
      const currentIdVariant = document.querySelector(".product-variant-id") ? document.querySelector(".product-variant-id").value : document.querySelector("product-add-cart").dataset.productId;

      const currentVariant = this.findCurrentVariant(currentIdVariant); 
      if (currentVariant && self.variantSelect ) {
        self.variantSelect.currentVariant = currentVariant;
        self.variantSelect.setAttribute("data-section",self.getAttribute("data-id-section"))
        self.variantSelect.setAttribute("data-url",self.getAttribute("data-url-product"))
        self.variantSelect.renderProductInfo();
      }
  }
  updateForm(button, quantity) {
      this.quantity.value = quantity
      if (button.dataset.actionButton == "increase") {
          if (this.minusButton.hasAttribute("disabled"))
              this.minusButton.removeAttribute("disabled")
      } else {
          if (this.plusButton.hasAttribute("disabled"))
              this.plusButton.removeAttribute("disabled")
      }
      if (+this.quantity.value >= +this.quantity.max || +this.quantity.value <= 0)
          button.setAttribute("disabled", true)
      if (+this.quantity.value > 0) {
          this.setAttribute("data-closed", false)
      }
      else {
          this.setAttribute("data-closed", true)
      }
  }
  handleDataConfig(button) {
      let typeRequest = "add"
      let quantity = 1
      if (button.dataset.actionButton != "increase") {
          typeRequest = "change"
          quantity = +this.quantity.value - 1
      }
      return { quantity, typeRequest }
  }

  addToCart(button) {
      if (this.dataset.productId == "") {
          return
      }

      if (!localStorage.getItem('postal_code') || !localStorage.getItem('delivery_city')) {
        const deliveryPopup = document.querySelector('delivery-popup') || null;
        deliveryPopup?.showPopup(deliveryPopup);
        return;
      }

      let { quantity, typeRequest } = this.handleDataConfig(button)
      let formData = {
          'id': this.dataset.productId,
          'quantity': quantity,
          'sections': this.cart?.getSectionsToRender().map((section) => section.id)
      };
      const config = fetchConfig('json');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.body = JSON.stringify(formData);

      fetch(`/cart/${typeRequest}.js`, config)
          .then((response) => response.json())
          .then(response => {
              if (response.status) {
                  return
              } if (this.cart) {
                  if (!(this.cart.notification && typeRequest == 'change')) {
                      if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
                      this.cart?.renderContents(response);
                      if (this.cart.querySelector("cart-drawer-items")?.classList.contains('is-empty')) this.cart.classList.add('is-empty')
                  }
                  const newQuantity = response.quantity
                      ?
                      response.quantity
                      :
                      response.items.filter(item => item.id == this.dataset.productId)?.length > 0
                          ? response.items.filter(item => item.id == this.dataset.productId)[0].quantity
                          : 0

                  this.updateForm(button, newQuantity)
              }
              else {
                  window.location.href = "/cart"
              }
          })
          .catch((error) => {
              console.error('Error:', error);
          }).finally(() => {
              this.renderProductAddCart();
          })
  }


  findCurrentVariant(id) {
      if (!this.jsonProduct || !id) return null;
      return [...this.jsonProduct].find( variant => Number(variant.id) === Number(id));
  }

}

customElements.define("product-add-cart",ProductAddCart)

class DeliveryPopup extends HTMLElement {
  constructor() {
      super();
      this.selectors = {
          popupOverlay: '.delivery-popup__overlay',
          popupCloseButton: '.delivery-popup__close-button',
          popupTitle: '.popup-content__title',
          popupTitleBack: '.popup-content__title--back-button',
          popupContent: '.popup-content__text',
          contentsObject: '.delivery-popup__contents-object',
          badge: '.delivery-badge',
          deliveryForm: '.delivery-popup__delivery-form',
          noDeliveryForm: '.delivery-popup__delivery-form--no-delivery',
          postalCodeInput: '.postal-code__input',
          postalCodeConfirmButton: '.delivery-form__button',
          deliveryZonesObject: '.delivery-zones__object'
      }
      this.contents = this.getPopupContent();
      this.deliveryData = this.getDeliveryData();
      this.currentPostalCode = localStorage.getItem('postal_code');
      this.isClosedByUser = Boolean(localStorage.getItem('is_delivery_popup_closed'));
      this.isSubscribedForDelivery = Boolean(localStorage.getItem('is_subscribed_for_delivery'));
  }

  connectedCallback() {
      this.attachEventListeners(this)
      this.handlePostalCodeConfirmation(this.currentPostalCode)
      
      if (this.currentPostalCode) document.querySelector(this.selectors.postalCodeInput).value = this.currentPostalCode;
      /* REDESIGN 2026-08-14 — do not open the postal popup on page load.
         It fired before anyone had seen the store. The gate itself is intact:
         addToCart (line ~1441) still calls showPopup when there is no postal
         code, so it is asked at the moment it is actually needed — which is
         also gopuff's flow. To restore the old behaviour, uncomment the line. */
      // if (!this.isClosedByUser) this.showPopup(this)

      if (!this.currentPostalCode) this.changeAllProductLinksBehaviour()
      if (this.currentPostalCode) document.querySelector(this.selectors.postalCodeConfirmButton).classList.add('delivery-form__button--is-filled')
  }

  attachEventListeners(popup) {
    document.querySelectorAll(this.selectors.badge)?.forEach(badge => {
        badge.addEventListener('click', () => this.showPopup(popup))
    }) 
    document.querySelectorAll([this.selectors.popupOverlay, this.selectors.popupCloseButton].join(',')).forEach(closeButton => {
        closeButton.addEventListener('click', () => this.closePopup(popup))
    })

    document.querySelector(this.selectors.postalCodeInput)?.addEventListener('input', (event) => event.target.value = this.getFormattedPostalCodeInput(event.target.value, event.inputType))

    document.querySelector(this.selectors.postalCodeConfirmButton).addEventListener('click', () => {
        const postalCodeValue = document.querySelector(this.selectors.postalCodeInput)?.value;
        this.handlePostalCodeConfirmation(postalCodeValue)
    })

    document.body.addEventListener('click', (event) => {
      if (event.target.classList.contains('popup-content__title--back-button') || event.target.querySelector('.popup-content__title--back-button')) {
          this.renderDeliveryPopupContent(true)
      }
    })
  }

  showPopup(popup) {
      popup.classList.add('delivery-popup--active')
      document.body.style = 'overflow: hidden; max-height: 100vh'
  }
  
  closePopup(popup) {
      popup.classList.remove('delivery-popup--active')
      document.body.style = 'overflow: auto; max-height: none';
      localStorage.setItem('is_delivery_popup_closed', true)
  } 

  getPopupContent() {
      try {
          return JSON.parse(this.querySelector(this.selectors.contentsObject)?.innerHTML);
      } catch(error) {
          console.warn('Error parsing popup content:', error)
      }
  }

  changeAllProductLinksBehaviour() {
    const linksToDisable = Array.from(document.querySelectorAll('a[href]')).filter(link => link.href.includes('/products/'))

    window.addEventListener('click', event => {
      if (this.currentPostalCode) return

      if (linksToDisable.includes(event.target) || linksToDisable.includes(event.target?.closest('a'))) {
        event.preventDefault();
        this.showPopup(this)
      }
    })
  }

  getDeliveryData() {
      const deliveryDataObject = document.querySelector(this.selectors.deliveryZonesObject);
      try {
          if (deliveryDataObject) return this.parseDeliveryData(JSON.parse(deliveryDataObject.innerHTML));
      } catch(error) {
          console.warn('Error parsing delivery data:', error)
      }
  }

  getFormattedPostalCodeInput(inputValue, inputType) {
      document.querySelector(this.selectors.postalCodeConfirmButton).classList.toggle('delivery-form__button--is-filled', inputValue.length >= 7)
      if (inputType == 'deleteContentBackward') return inputValue
      
      let formattedString = (inputValue.slice(0, 3) + (inputValue.length >= 3 ? ' ' : '') + inputValue.slice(4)).slice(0, 7).toUpperCase();
      return formattedString.length > 0 ? formattedString : inputValue.toUpperCase();
  }

  parseDeliveryData(deliveryData) {
      if (!deliveryData || !deliveryData.delivery_zones) {
          return {};
      }
  
      return Object.entries(deliveryData.delivery_zones).reduce((parsedDeliveryData, [key, zoneData]) => {
          const { display_name: zoneName, delivery_message: deliveryMessage, estimated_delivery_date: estimatedDeliveryDate, show_express_shipping: showExpressShipping } = zoneData;
  
          (zoneData.postal_codes_and_cities || []).forEach(deliveryCorrespondence => {
              const [postalCode, city] = deliveryCorrespondence.split('--');
  
              parsedDeliveryData[postalCode] = {
                  city,
                  zone: zoneName,
                  message: deliveryMessage,
                  delivery_date: estimatedDeliveryDate,
                  show_express_shipping: showExpressShipping
              };
          });
  
          return parsedDeliveryData;
      }, {});
  }

  handlePostalCodeConfirmation(inputValue) {
      if (!inputValue) return

      this.togglePostalCodeError(false)
      const regex = /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i;
      
      if (regex.test(inputValue)) {
          const postalCodeMainPart = inputValue.slice(0,3);
          const currentZoneDeliveryData = this.deliveryData[postalCodeMainPart];
          if (localStorage.getItem('postal_code') != inputValue) {
              localStorage.setItem('postal_code', inputValue);
              this.currentPostalCode = inputValue;
              localStorage.setItem('is_subscribed_for_delivery', '')
              this.isSubscribedForDelivery = false;
          }

          
          if (currentZoneDeliveryData) {
              this.renderDeliveryBadgeContent(true, inputValue, currentZoneDeliveryData);
              this.renderDeliveryPopupContent(true)
              this.closePopup(this)
              /* REDESIGN — replay the add that opened this popup. Both keys the
                 cart gate checks are set by now: postal_code above, and
                 delivery_city inside renderDeliveryBadgeContent. */
              if (window.__ubPendingAdd) {
                  const replay = window.__ubPendingAdd;
                  window.__ubPendingAdd = null;
                  setTimeout(replay, 60);
              }
          } else {
              this.renderDeliveryBadgeContent(false, inputValue)
              this.renderDeliveryPopupContent(false)
              /* REDESIGN — out of zone. renderDeliveryBadgeContent(false, ...)
                 sets delivery_city to '', so the cart gate stays shut and every
                 future + would silently do nothing. Discard the pending add. */
              window.__ubPendingAdd = null;
              if (!this.isSubscribedForDelivery) {
                  let _learnq = window._learnq || [];
                  _learnq.push(['identify', {
                      'Postal Code' : inputValue
                    }]);
                  localStorage.setItem('is_subscribed_for_delivery', 'true')
                  this.isSubscribedForDelivery = true;
              }
          }          
      } else {
          this.togglePostalCodeError(true)
      }
  }

  renderDeliveryPopupContent(hasDelivery) {
      const contents = hasDelivery ? this.contents.hasDelivery : this.contents.noDelivery;
      const popupTitle = this.querySelector(this.selectors.popupTitle);
      const popupContent = this.querySelector(this.selectors.popupContent);
      const popupDeliveryForm = this.querySelector(this.selectors.deliveryForm);
      const popupNoDeliveryForm = this.querySelector(this.selectors.noDeliveryForm);
  
      popupTitle.innerHTML = contents.heading;
      popupContent.innerHTML = hasDelivery ? contents.content : contents.content.replace('/code/', this.currentPostalCode);
      popupTitle.classList.toggle('popup-content__title--back-button', !hasDelivery);
      popupContent.classList.toggle('popup-content__text--no-delivery', !hasDelivery);
      popupDeliveryForm.style.display = hasDelivery ? 'block' : 'none';
      popupNoDeliveryForm.style.display = hasDelivery ? 'none' : 'block';
  }

  renderDeliveryBadgeContent(hasDelivery, postalCode, deliveryData) {
    document.querySelectorAll(this.selectors.badge).forEach(badge => {
      if (deliveryData && deliveryData.message) {
        badge.innerHTML = `
        <span class="delivery-badge__postal-code">
            ${postalCode + '-' + deliveryData.city?.toUpperCase()}
        </span>
        ${deliveryData.message !== undefined
          ? `<div class="delivery-badge__estimate">${deliveryData.message}</div>`
          : ""
        }
      `
      }else {
        badge.innerHTML = hasDelivery ?
        `
            <span class="delivery-badge__postal-code">
                ${postalCode + '-' + deliveryData.city?.toUpperCase()}
            </span>
            ${deliveryData.delivery_date !== undefined
              ? `<div class="delivery-badge__estimate">${deliveryData.delivery_date == 0 ? 'same' : deliveryData.delivery_date}-day delivery</div>`
              : ""
            }
        ` :
        `
        <div class="delivery-badge__postal-code--empty">
            ${this.contents.noDelivery.badgePlaceholder}
        </div>
        `
      }
    })

    localStorage.setItem('delivery_city', hasDelivery ? deliveryData.city : '')
    localStorage.setItem('is_express_shipping_banner_showed', hasDelivery ? deliveryData.show_express_shipping : '')
  }

  togglePostalCodeError(setActive = true) {
      const deliveryForm = document.querySelector(this.selectors.deliveryForm)
      if (setActive) {
          deliveryForm.classList.add('delivery-popup__delivery-form--has-error')
      } else {
          deliveryForm.classList.remove('delivery-popup__delivery-form--has-error')
      }
  }
}

customElements.define("delivery-popup", DeliveryPopup);


class CollapseRow extends HTMLElement {
  constructor() {
    super()
    this.buttonTriger = this;
    this.buttonTriger.addEventListener("click", this.toggleContent )
  }

  toggleContent() {
    const { parentElement, nextElementSibling } = this.buttonTriger;
    const { scrollHeight } = nextElementSibling;
    const isOpen = parentElement.dataset.open === "false" ? true : false;
    nextElementSibling.style.maxHeight = isOpen ? scrollHeight * 2 + "px" : 0;
    parentElement.setAttribute("data-open", String(isOpen))
  }
}


customElements.define('collapse-row', CollapseRow);

class PredictiveSearchHeader extends HTMLElement {
  constructor() {
    super();
    this.cachedResults = {};
    this.isOpen = false;
    this.searchTerm = '';
    this.abortController = new AbortController();
    this.input = this.querySelector(".header__search-input") || this.querySelector(".header-search__input");
    this.form = this.querySelector("form");
    this.predictiveResults = document.querySelector(".predictive-results");
    this.resultContainer = this.predictiveResults.querySelector(".predictive-results__response");
    this.safelyField = this.predictiveResults.querySelector(".predictive-results__wrapper");
    this.closeButton = document.querySelector(".predictive-results__close");
    this.allLinkPopular = document.querySelectorAll(".predictive-results__initial-list-popular a");

    this.setupEventListeners();
    this.input.removeAttribute("disabled")

  }

  setupEventListeners() {
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.form.addEventListener('submit', this.onSubmit.bind(this));
    this.input.addEventListener('focus', this.open.bind(this));
    this.input.addEventListener('input', debounce((event) => { this.onChange(event); }, 500).bind(this));
    this.predictiveResults.addEventListener("click", this.close.bind(this));
    this.closeButton.addEventListener("click", this.close.bind(this));
    this.safelyField.addEventListener("click", (event) => event.stopPropagation());
    this.allLinkPopular.forEach( link => link.addEventListener("click",this.savePopularQuery.bind(this)))
  }

  savePopularQuery(event) {
    const query = event.target?.textContent;
    if (typeof query === "string") {
      this.saveQuery(query);
    }
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    this.getSearchResults(this.getQuery());
  }

  open() {
    this.isOpen = true;
    this.predictiveResults.setAttribute("data-open", "true");
    document.body.classList.add("disabled-scroll");
  }

  close() {
    this.isOpen = false;
    this.predictiveResults.setAttribute("data-open", "false");
    document.body.classList.remove("disabled-scroll");
    this.input?.blur();
  }
  onKeyup(event) {
    event.preventDefault();
    if (event.code === "Escape" || event.code === "27") {
     this.close(); 
    }
  }

  onSubmit(event) {
    event.preventDefault();
    const currentQuery = this.getQuery();
    if (currentQuery.length !== 0) {
      this.saveQuery(currentQuery);
      window.location.href = `/search?q=${currentQuery}&options%5Bprefix%5D=last`
    }
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(' ', '-').toLowerCase();

    if (queryKey.length === 0) {
      this.renderInitialResult();
      this.predictiveResults.setAttribute("data-result", "false")
      return
    }

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey],searchTerm);
      this.predictiveResults.setAttribute("data-result", "true")
      return;
    }
    fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&resources[type]=product&resources[options][fields]=vendor,title,body,variants.title&section_id=header-predictive-search`, {
      signal: this.abortController.signal,
    })
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }
        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          ?.parseFromString(text, 'text/html')
          ?.querySelector('#shopify-section-header-predictive-search').innerHTML;
        this.renderSearchResults(resultsMarkup,searchTerm);
        this.cachedResults[queryKey] = resultsMarkup;
        this.predictiveResults.setAttribute("data-result", "true")
      })
      .catch((error) => {
        if (error?.code === 20) {
          // Code 20 means the call was aborted
          return;
        }
        this.close();
        this.renderInitialResult();
        throw error;
      });
  }

  renderSearchResults(markup,searchTerm) {
    this.resultContainer.innerHTML = markup;
    const listSpan = this.resultContainer.querySelectorAll("#predictive-search-results-products-list a span");
    this.highlightTextInSpan(listSpan,searchTerm)

  }

  highlightTextInSpan(htmlCollection = [], searchText = "") {
    for (let i = 0; i < htmlCollection.length; i++) {
      const text = htmlCollection[i].textContent || htmlCollection[i].innerText;
      const regex = new RegExp(searchText, 'gi');
      const matches = text.match(regex);
      if (matches) {
        const highlightedText = text.replace(regex, '<strong>$&</strong>');
        htmlCollection[i].innerHTML = highlightedText;
      }
    }
  }
  
  renderInitialResult() {
    this.resultContainer.innerHTML = "";
    this.predictiveResults.setAttribute("data-result", "false");
  }

  saveQuery(query) {
    const queryKey = query.replace(' ', '-').toLowerCase();
    const searchQuery = JSON.parse(localStorage.getItem("searchQuery")) || [];

    if (searchQuery.some(item => item.key === queryKey)) return;

    const itemStore = {
      key: queryKey,
      query: query
    };
    searchQuery.push(itemStore);
    localStorage.setItem("searchQuery", JSON.stringify(searchQuery));
  }

  static createLocalQuery() {
    const listOfResent = document.querySelector("#list-recent");
    const searchQuery = JSON.parse(localStorage.getItem("searchQuery")) || [];
    const queryItems = searchQuery.map(query => this.createItem(query.query));
    listOfResent.append(...queryItems);
    this.isCreatedLocally = true;
  }

  static createItem(query) {
    const li = document.createElement("li");
    li.classList.add("predictive-results__initial-item")
    const a = document.createElement("a");
    a.classList.add("predictive-results__initial-link")
    a.href = `/search?q=${query}&type=product&options[prefix]=last`;
    a.textContent = query;
    li.append(a);
    return li;
  }

}
customElements.define('predictive-search-header', PredictiveSearchHeader);
PredictiveSearchHeader.createLocalQuery();

class VideoPopup extends HTMLElement {
  constructor() {
    super()
    this.popup = this
    this.video = this.querySelector("video");
    this.containerElement = this.closest(".is-video")?.querySelector(".video-play");
    this.init();
  }

  init() {
    if (!this.containerElement) {
      throw new Error("Please check that you have inserted all classes according to the snippet'video-pop-up'")
    }
    this.setupEventListeners(this.popup,this.containerElement);
    this.video?.addEventListener("click", (event) => event.stopPropagation());

  }

  setupEventListeners(...htmlCollection) {
    [...htmlCollection].forEach( htmlElement => {
      if (!htmlElement) return
      htmlElement?.addEventListener("click",this.toggleVideo.bind(this))
    });  
  }

  toggleVideo() {
    const isActive = this.popup.classList.contains("video-popup--active");
    this.popup.classList.toggle("video-popup--active",!isActive);
    document.body.classList.toggle("overflow-hidden",!isActive);
    this.video?.paused ? this.video.play() : this.video.pause();
  }
}
customElements.define("video-popup",VideoPopup);


class WaitlistPopup extends HTMLElement {
  constructor() {
    super();
    this.closeElements = this.querySelectorAll(".popup-waitlist__button, .waitlist-popup__overlay");
    this.form = this.querySelector(".popup-waitlist__form");
    this.formSubmit = this.form.querySelector("button");
    this.errorText = this.form.querySelector(".waitlist__form-error-text");
    
    this.bindEventListeners();
  }

  bindEventListeners() {
    this.closeElements.forEach(htmlTag => {
      htmlTag?.addEventListener("click", this.togglePopup.bind(this));
    });

    this.form.addEventListener("submit", this.handleFormSubmit.bind(this));
  }

  createErrorMessage(text) {
    if (!this.errorText) return;
    this.errorText.innerHTML = text;
    this.errorText.classList.add("error-show");
    setTimeout(() => {
      this.errorText.innerHTML = "";
      this.errorText.classList.remove("error-show");
    }, 2000);
  }

  handleFormSubmit(event) {
    event.preventDefault();
    const emailInput = this.form.querySelector("input.waitlist__form-email");
    const email = emailInput.value.trim();

    if (!this.isValidEmail(email)) {
      this.createErrorMessage("Please enter a valid email address");
      return;
    }

    const productId = this.getProductId();
    if (!productId) {
      console.log("Product ID not found.");
      return;
    }

    this.addToWaitList(productId, email);
    this.addToListSegment(email);

    this.form.reset();
  }

  isValidEmail(email) {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
  }

  getProductId() {
    const waitlistButton = document.querySelector(".product-buttons__waitlist");
    if (!waitlistButton) return null;
    return waitlistButton.dataset.soldId;
  }

  togglePopup() {
    this.classList.toggle("product__waitlist--active");
  }

  // Method to add to waitlist
  addToWaitList(id, email) {
    const payload = {
      data: {
        type: "back-in-stock-subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: {
                email: email
              }
            }
          },
          channels: ["EMAIL"]
        },
        relationships: {
          variant: {
            data: {
              type: "catalog-variant",
              id: `$shopify:::$default:::${id}`
            }
          }
        }
      }
    };

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "revision": "2023-12-15"
      },
      body: JSON.stringify(payload)
    };

    fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=TcSSDG", requestOptions)
      .then(response => {
        if (!response.ok) {
          throw new Error("Failed to add to waitlist.");
        }
        console.log("Added to waitlist.");
        this.togglePopup();
      })
      .catch(error => console.error('Error adding to waitlist:', error));
  }

  // Method to add to list segment
  addToListSegment(email) {
    const payload = {
      data: {
        type: "subscription",
        attributes: {
          custom_source: "Back in stock",
          profile: {
            data: {
              type: "profile",
              attributes: {
                email: email
              }
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: "list",
              id: "QYD4SL"
            }
          }
        }
      }
    };

    const requestOptions = {
      method: "POST",
      headers: {
        "revision": "2024-02-15",
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload)
    };

    fetch("https://a.klaviyo.com/client/subscriptions/?company_id=TcSSDG", requestOptions)
      .then(response => {
        if (!response.ok) {
          throw new Error("Failed to add to list segment.");
        }
        console.log("Added to list segment.");
      })
      .catch(error => console.error('Error adding to list segment:', error));
  }
}

customElements.define("waitlist-popup", WaitlistPopup);


document.addEventListener("DOMContentLoaded", function() {
  const prevPage = document.referrer;
  const regex = new RegExp('cart', 'g');
  const isCartPage = regex.test(prevPage);
  const isOpened = localStorage.getItem("open-cart") === "true" ? true : false;
  if (isCartPage && !isOpened) {
    document.querySelector('cart-drawer')?.open();
    localStorage.setItem("open-cart", "true")
  } else {
    localStorage.setItem("open-cart", "false")
  }
});

class BlogSearch extends HTMLElement {
  constructor() {
      super()
      this.searchTerm = '';
      this.searchTags = [];
      this.input = this.querySelector(".blog-search__input");
      this.initalArticles = document.querySelectorAll(".blog-articles__article");
      this.parentBlog = document.querySelector(".blog-articles");
      this.abortController = new AbortController();
      this.loadMoreButton = document.querySelector(".main-blog__button");
      this.maxArticle = this.loadMoreButton?.dataset.items || 0;
  }

  connectedCallback() {
      this.input.addEventListener('input', debounce((event) => { this.onChange(event); }, 500).bind(this));
      this.searchTags = this.extractTagsFromURL(window.location.href);
  }

  onChange() {
    this.input.classList.toggle("blog-search__input--active", this.getQuery().length != 0),
    this.getSearchResults(this.getQuery())
  }

  getQuery() {
      return this.input.value.trim();
  }

  extractTagsFromURL(url) {
      const urlParts = url.split("/");
      const taggedIndex = urlParts.indexOf("tagged");
      if (taggedIndex === -1) {
          return [];
      }
      const tags = urlParts.slice(taggedIndex + 1).map(tag => tag.replaceAll("-", " "));
      return tags;
  }

  getSearchResults(searchTerm) {
    if (searchTerm.length === 0) {
      this.renderDefaultSearch([...this.initalArticles]);
      return
    }
      fetch(window.Shopify.routes.root + `search/suggest?q=${encodeURIComponent(searchTerm)}&resources[type]=article&section_id=api-blog-search`, {
          signal: this.abortController.signal,
      })
          .then((response) => {
            if (!response.ok) {
              throw new Error(response.status);
            }
            return response
          })
          .then((response) => response.text())

          .then((response) => {
              const resultsMarkup = new DOMParser()?.parseFromString(response, 'text/html').querySelector('#predictive-search-results');
              const errorText = resultsMarkup?.querySelector(".blog-articles__article-no-results");
              const allArticles = resultsMarkup.querySelectorAll(".blog-articles__article");
              if (!allArticles.length) {
                this.renderNoSearchText(errorText);
                this.changeStateLoadMore(true);
                return;
              }
              if (allArticles && !allArticles.length) {
                this.renderSearchResults(allArticles)
                return
              }
              let filterResult = allArticles;
              if (filterResult && filterResult.length != 0 && this.searchTags.length != 0) {
                  filterResult = [...allArticles].filter(article => {
                      const { dataset: { tags } } = article
                      const regex = new RegExp(this.searchTags[0], 'g');
                      const isTagInArticle = regex.test(tags);
                      if (isTagInArticle) {
                          return article;
                      }
                  })
              }
              this.renderSearchResults(filterResult);
          }).catch( (error) => {
            console.log(error);
            this.renderDefaultSearch([...this.initalArticles]);
          })
  }
  renderSearchResults(array) {
    this.parentBlog.innerHTML = "";
    if (!array.length) {
      this.renderDefaultSearch() 
      return
    }
    array.forEach( nodeElement => this.parentBlog.append(nodeElement));
    this.changeStateLoadMore(true);
  }
  renderDefaultSearch() {
    this.parentBlog.innerHTML = "";
    [...this.initalArticles].forEach( nodeElement => this.parentBlog.append(nodeElement));
    this.changeStateLoadMore();
  }
  changeStateLoadMore(isAdd) {
    let flag = isAdd ? isAdd : this.initalArticles.length >= this.maxArticle;
    this.loadMoreButton?.classList.toggle("disabled-button",flag)
  }
  renderNoSearchText(errorText) {
    if (!errorText) {
      throw new Error("Error text not found")
    }
    this.parentBlog.innerHTML = "";
    this.parentBlog.append(errorText)
  }

}

customElements.define("blog-search", BlogSearch);
// document.addEventListener('DOMContentLoaded', function () {//delete
//   document.querySelector('cart-drawer')?.open() 
// })

